import { render, staticRenderFns } from "./AppNotifications.vue?vue&type=template&id=4a701090&scoped=true&"
import script from "./AppNotifications.vue?vue&type=script&lang=ts&"
export * from "./AppNotifications.vue?vue&type=script&lang=ts&"
import style0 from "./AppNotifications.vue?vue&type=style&index=0&id=4a701090&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a701090",
  null
  
)

export default component.exports